import { Marquee } from "@/components/site/Marquee";
import boletaje from "@/assets/clients/boletaje.webp";
import butcherjames from "@/assets/clients/butcherjames.webp";
import boxchois from "@/assets/clients/boxchois.webp";
import fashionablecanes from "@/assets/clients/fashionablecanes.webp";
import medshift from "@/assets/clients/medshift.webp";
import classy from "@/assets/clients/classywalkingcanes.webp";
import cleveland from "@/assets/clients/clevelandkitchen.webp";
import pokerpower from "@/assets/clients/pokerpower.webp";
import redondo from "@/assets/clients/redondobrand.webp";
import selfcare from "@/assets/clients/selfcareisforeveryone.webp";
import threadseed from "@/assets/clients/threadseed.webp";
import oomame from "@/assets/clients/oomame.webp";
import boletajeSm from "@/assets/clients/boletaje-sm.webp";
import butcherjamesSm from "@/assets/clients/butcherjames-sm.webp";
import boxchoisSm from "@/assets/clients/boxchois-sm.webp";
import fashionablecanesSm from "@/assets/clients/fashionablecanes-sm.webp";
import medshiftSm from "@/assets/clients/medshift-sm.webp";
import classySm from "@/assets/clients/classywalkingcanes-sm.webp";
import clevelandSm from "@/assets/clients/clevelandkitchen-sm.webp";
import pokerpowerSm from "@/assets/clients/pokerpower-sm.webp";
import redondoSm from "@/assets/clients/redondobrand-sm.webp";
import selfcareSm from "@/assets/clients/selfcareisforeveryone-sm.webp";
import threadseedSm from "@/assets/clients/threadseed-sm.webp";
import oomameSm from "@/assets/clients/oomame-sm.webp";

const CLIENTS: Array<[string, string]> = [
  [boletaje, boletajeSm], [butcherjames, butcherjamesSm], [boxchois, boxchoisSm],
  [fashionablecanes, fashionablecanesSm], [medshift, medshiftSm], [classy, classySm],
  [cleveland, clevelandSm], [pokerpower, pokerpowerSm], [redondo, redondoSm],
  [selfcare, selfcareSm], [threadseed, threadseedSm], [oomame, oomameSm],
];

export function ClientsSection({ header }: { header: string }) {
  return (
    <>
      <p className="mb-8 text-center text-xs font-medium uppercase tracking-[0.25em] text-muted-foreground">
        {header}
      </p>
      <Marquee>
        {CLIENTS.map(([src, srcSm], i) => (
          <img
            key={i}
            src={src}
            srcSet={`${srcSm} 196w, ${src} 351w`}
            sizes="(max-width: 768px) 196px, 351px"
            alt=""
            width={120}
            height={40}
            loading="lazy"
            decoding="async"
            className="h-10 w-auto opacity-60 transition-opacity hover:opacity-100"
            aria-hidden="true"
          />
        ))}
      </Marquee>
    </>
  );
}